import { render, staticRenderFns } from "./ConsultantListView.vue?vue&type=template&id=38ba3ce2&scoped=true"
import script from "./ConsultantListView.vue?vue&type=script&lang=js"
export * from "./ConsultantListView.vue?vue&type=script&lang=js"
import style0 from "./ConsultantListView.vue?vue&type=style&index=0&id=38ba3ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ba3ce2",
  null
  
)

export default component.exports